import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { PotentialMatch } from './useMatching';

interface DiscoveryFilters {
  pet_id: string;
  match_type?: 'playdate' | 'breeding' | 'friendship' | 'adoption';
  max_distance_km?: number;
  min_score?: number;
  limit?: number;
}

export const useMatchDiscovery = (filters: DiscoveryFilters) => {
  return useQuery({
    queryKey: ['match-discovery', filters],
    queryFn: async () => {
      if (!filters.pet_id) {
        return { matches: [], count: 0 };
      }

      const { data, error } = await supabase.functions.invoke('find-pet-matches', {
        body: {
          pet_id: filters.pet_id,
          match_type: filters.match_type || 'playdate',
          max_distance_km: filters.max_distance_km || 50,
          limit: filters.limit || 20
        }
      });

      if (error) {
        console.error('Error finding matches:', error);
        throw error;
      }

      let matches = (data?.matches || []) as PotentialMatch[];

      // Apply min_score filter client-side if needed
      if (filters.min_score && filters.min_score > 0) {
        matches = matches.filter(m => m.compatibility_score >= (filters.min_score || 0));
      }

      return {
        matches,
        count: matches.length
      };
    },
    enabled: !!filters.pet_id,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10 // 10 minutes (formerly cacheTime)
  });
};
